export default "/dist/files/tick.6114ccc3840e0562e629c90ad3925b1e.svg";